import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useCallback} from 'react'

import {getFirstComment} from '../../../page-data/payloads/thread-previews'
import {useNavigateToComment, usePullRequestBasePath} from '../../../stores/layout-selectors'
import {addUrlToHistoryStack} from '@github-ui/history'
import {useNavigate} from '@github-ui/use-navigate'

export const useNavigateToFirstComment = (thread: Thread, onNavigateToDiffComment: () => void) => {
  const firstComment = getFirstComment(thread)
  const navigateToSelectedComment = useNavigateToComment()
  const basePath = usePullRequestBasePath()
  const navigate = useNavigate()

  const isOutdated = thread.isOutdated || thread.subject?.isOutdated || thread.positioning?.isOutdated || false

  return useCallback(() => {
    const databaseId = firstComment?.databaseId
    if (!databaseId) return

    if (isOutdated && thread.originalDiffPathUri) {
      // eslint-disable-next-line no-restricted-syntax
      const url = new URL(thread.originalDiffPathUri)
      url.searchParams.set('new_files_changed', 'true')

      window.location.href = url.toString()
    } else if (navigateToSelectedComment) {
      navigateToSelectedComment(databaseId)
      const currentUrl = window.location.pathname + window.location.search
      addUrlToHistoryStack(`${currentUrl}#r${databaseId}`)
    } else {
      navigate(`${basePath}/changes#r${databaseId}`)
    }
    window.requestAnimationFrame(() => {
      onNavigateToDiffComment()
    })
  }, [
    firstComment?.databaseId,
    isOutdated,
    thread.originalDiffPathUri,
    navigateToSelectedComment,
    navigate,
    basePath,
    onNavigateToDiffComment,
  ])
}
